<template>
<!--  -->
  <el-carousel
    class="carousel-el pc-margin-bottom30-mobil-margin-bottom20 border-radius5"
    :height="carouselHeight"
    v-if="cptFlag"
    >
    <el-carousel-item
      v-for="(item,index) in computedList"
      :key="index"
    >
      <div class="bg-img-box"
           :class="{pointer: getIsPointer(item)}"
        @click="carouselImageHandle(item)"
        :style="{
          backgroundImage: `url(${getImgUrl(item)})`,
        }"
      ></div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDynamicInfo } from '@/api/userCenter'
export default  {
  name: 'homeCarousel',
  data() {
    return {
      listData: null,
      cptFlag: true,
    };
  },
  created(){
    this.getList();
  },
  computed: {
    ...mapGetters(['language','realMobile','device']),
    computedList(){
      if(this.listData && this.listData.length){
        if(this.language == 'zh_CN'){
          //中文版
          if(!this.realMobile){
            // PC端
            return this.listData.filter((item) =>{
              return item.imgPc;
            })
          }else if(this.realMobile){
            // 移动端
            return this.listData.filter((item) =>{
              return item.imgMobile;
            })
          }
        }else  if(this.language == 'en_US'){
          // 英文版
          if(!this.realMobile){
            // PC端
            return this.listData.filter((item) =>{
              return item.imgPcEn;
            })
          }else if(this.realMobile){
            // 移动端
            return this.listData.filter((item) =>{
              return item.imgMobileEn;
            })
          }
        }else  if(this.language == 'zh_Hant'){
          // 英文版
          if(!this.realMobile){
            // PC端
            return this.listData.filter((item) =>{
              return item.imgPcHant;
            })
          }else if(this.realMobile){
            // 移动端
            return this.listData.filter((item) =>{
              return item.imgMobileHant;
            })
          }
        }
      }else {
        return [];
      }
    },
    carouselHeight(){
      if(this.device == 'mobile'){
        return '150px';
      }else {
        return '300px';
      }
    },
  },
  methods: {
    getIsPointer(item){
      if(item.redirectUrl){
        return true;
      }else {
        return false;
      }
    },
    carouselImageHandle(item) {
      if(!item.redirectUrl) return;
      window.open(item.redirectUrl,'_blank')
    },
    getList(){
      getDynamicInfo({
        type: 1,
      }).then((res) => {
        this.listData = res.data || [];
        this.cptFlag = this.listData.length;
      })
    },
    getImgUrl(item){
      if(this.language == 'zh_CN'){
        //中文版
        if(!this.realMobile){
          // PC端
          return item.imgPc;
        }else if(this.realMobile){
          // 移动端
          return item.imgMobile;
        }
      }else if(this.language == 'en_US') {
        // 英文版
        if(!this.realMobile){
          // PC端
          return item.imgPcEn;
        }else if(this.realMobile){
          // 移动端
          return item.imgMobileEn;
        }
      }else if(this.language == 'zh_Hant'){
        // 繁体版
        if(!this.realMobile){
          // PC端
          return item.imgPcHant;
        }else if(this.realMobile){
          // 移动端
          return item.imgMobileHant;
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/variable";
.carousel-el {
  .bg-img-box {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }
  .el-carousel__indicator {
    .el-carousel__button {
      width: 10px;
      height: 10px;
      background-color: #E6E6E6;
      border-radius: 50%;
    }
    &.is-active .el-carousel__button {
      background-color: $themeColor;
    }
  }
  .el-carousel__arrow {
    background-color: rgba(0,0,0, 0.6);
  }
}
</style>
